var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-flex-col gl-gap-2 gl-text-sm"},[_c('div',{staticClass:"gl-flex gl-items-end gl-gap-2"},[_c('span',{staticClass:"gl-text-xs gl-font-semibold gl-uppercase gl-tracking-widest gl-text-control-placeholder"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_vm._t("label-append")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }